// Structs.
import { CategoryCardinalityStruct } from '../util/category-cardinality.struct';
import { IdLabelStruct } from '../util/id-label.struct';
// Classes.
import { LoggedComponent } from '../logger/logged-component';
// Providers
import { LoggerService } from '../logger/logger-service';
import * as i0 from "@angular/core";
import * as i1 from "../logger/logger-service";
export class WaHelperService extends LoggedComponent {
    constructor(logger) {
        super(logger);
        this.logger = logger;
        /*****************************************************************************
         *  Data in memory
         ****************************************************************************/
        this.cateogryById = {};
        this.cateogryByCode = {};
        this.countryNamesByNoc = {};
    }
    addCountryNameItem(item) {
        this.countryNamesByNoc[item.noc] = item;
    }
    getCountryNamesInfo(noc) {
        return this.countryNamesByNoc[noc];
    }
    addCategoryItem(item) {
        this.cateogryByCode[item.code] = this.cateogryById[item.id] = item;
    }
    getCategoryInfoById(id) {
        return this.cateogryById[id];
    }
    getCategoryInfoByCode(code) {
        return this.cateogryByCode[code];
    }
    /**
     * Returns the coutry name given a noc.
     */
    nocToCountryName(noc, nameType = "short") {
        let countryName = 'Unknown';
        if (typeof this.countryNamesByNoc[noc] !== 'undefined') {
            countryName = this.countryNamesByNoc[noc][nameType];
        }
        return countryName;
    }
    /**
     * Returns the coutry flag pic url given a noc.
     */
    nocToFlagUrl(noc, size = 'small') {
        let sizeCode;
        switch (size) {
            case 'small':
                sizeCode = 'S';
                break;
            case 'medium':
                sizeCode = 'M';
                break;
            case 'large':
                sizeCode = 'L';
                break;
        }
        return `https://extranet.worldarchery.sport/Flags/${noc}-${sizeCode}.png`;
    }
    getLevelListInfo() {
        let levelsInfo = [];
        Object.keys(WaHelperService.levelInfo).forEach(key => levelsInfo.push(WaHelperService.levelInfo[key]));
        return levelsInfo;
    }
    /**
     * Returns division info given division code.
     */
    getLevelInfo(levelId) {
        let levelInfo = new IdLabelStruct(levelId, 'Unknown');
        if (WaHelperService.levelInfo[levelId]) {
            levelInfo = WaHelperService.levelInfo[levelId];
        }
        return levelInfo;
    }
    getLevelIdByLevelGroupName(levelGroup) {
        let levels;
        switch (levelGroup) {
            case 'international':
                levels = [1, 2, 3, 4];
                break;
            case 'continental':
                levels = [5, 6, 7];
                break;
            case 'national':
                levels = [8, 9, 10];
                break;
            case 'ALL':
                levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                break;
        }
        return levels;
    }
    getDivisionListInfo() {
        let divisionsInfo = [];
        Object.keys(WaHelperService.divisionInfo).forEach(key => divisionsInfo.push(WaHelperService.divisionInfo[key]));
        return divisionsInfo;
    }
    /**
     * Returns division info given division code.
     */
    getDivisionInfo(divCode) {
        let divisionInfo = new IdLabelStruct(divCode, 'Unknown');
        if (WaHelperService.divisionInfo[divCode]) {
            divisionInfo = WaHelperService.divisionInfo[divCode];
        }
        return divisionInfo;
    }
    /**
     * Returns the label of a division given its code
     */
    divisionCodeToLabel(divCode) {
        return this.getDivisionInfo(divCode).label;
    }
    demuxCategoryAndCardinality(rawValue) {
        let demuxed = null;
        if (rawValue) {
            let catComponents = rawValue.split('-');
            demuxed = new CategoryCardinalityStruct(catComponents[0], catComponents[1] === 't');
        }
        return demuxed;
    }
    muxCategoryAndCardinality(value) {
        let muxed = null;
        if (value) {
            let components = [value.catCode, value.isTeam ? 't' : 'i'];
            muxed = components.filter(v => v).join('-');
        }
        return muxed;
    }
    formatDate(date, format = 'long') {
        let formatedDate;
        let dateMonthNumber = date.getMonth() + 1;
        let monthLabel = (dateMonthNumber < 10 ? '0' : '') + dateMonthNumber;
        let dateDayNumber = date.getDate();
        let dateDayLabel = (dateDayNumber < 10 ? '0' : '') + dateDayNumber;
        switch (format) {
            case 'webservice':
                formatedDate = formatedDate = `${date.getFullYear()}${monthLabel}${dateDayLabel}`;
                break;
            case 'widget':
                formatedDate = formatedDate = `${date.getFullYear()}-${monthLabel}-${dateDayLabel}`;
                break;
            case 'short':
                formatedDate = formatedDate = `${dateDayLabel}/${monthLabel}/${date.getFullYear()}`;
                break;
            case 'monthYearShort':
                formatedDate = `${date.getMonth() + 1}/${date.getFullYear()}`;
                break;
            case 'year':
                formatedDate = `${date.getFullYear()}`;
                break;
            case 'long':
            default:
                formatedDate = `${dateDayLabel} ${WaHelperService.monthNames[date.getMonth()]} ${date.getFullYear()}`;
                break;
        }
        return formatedDate;
    }
    static formatDateRange(from, to) {
        let dateString;
        let matching = 0;
        if (from.getFullYear() === to.getFullYear()) {
            matching++;
            if (from.getMonth() === to.getMonth()) {
                matching++;
                if (from.getDate() === to.getDate()) {
                    matching++;
                }
            }
        }
        switch (matching) {
            case 0:
                dateString = `${from.getDate()} ${WaHelperService.monthNames[from.getMonth()]} ${from.getFullYear()} - ${to.getDate()} ${WaHelperService.monthNames[to.getMonth()]} ${to.getFullYear()}`;
                break;
            case 1:
                dateString = `${from.getDate()} ${WaHelperService.monthNames[from.getMonth()]} - ${to.getDate()} ${WaHelperService.monthNames[to.getMonth()]} ${to.getFullYear()}`;
                break;
            case 2:
                dateString = `${from.getDate()}-${to.getDate()} ${WaHelperService.monthNames[to.getMonth()]} ${to.getFullYear()}`;
                break;
            case 3:
                dateString = `${from.getDate()} ${WaHelperService.monthNames[from.getMonth()]} ${from.getFullYear()}`;
                break;
        }
        return dateString;
    }
    /**
     * Method for get the combo season item by current year.
     *
     * @returns {PrizeForPrecisionYear}
     * @param PrizeForPrecisionYear[]
     * @public
     * @returns
     */
    static getComboSeasonItemByCurrentYear(comboSeason) {
        // const currentYear = new Date().getFullYear()
        const currentYear = 2026; // Forced  to  2026 for take the last season #Task: https://app.asana.com/1/44511833986982/project/1207725188900996/task/1210705958663285
        if (comboSeason) {
            return comboSeason.find(value => value.Year === currentYear);
        }
        else {
            return { Year: currentYear, Discipline: 2, Series: '', PrecisionPrize: false };
        }
    }
}
WaHelperService.monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
/**
 * List of level info: code and name.
 */
WaHelperService.levelInfo = {
    1: new IdLabelStruct(1, 'Olympic Games'),
    2: new IdLabelStruct(2, 'World Championships'),
    3: new IdLabelStruct(3, 'World Cup'),
    4: new IdLabelStruct(4, 'Multisport World Event'),
    5: new IdLabelStruct(5, 'Multisport Continental Event'),
    6: new IdLabelStruct(6, 'Continental Games'),
    7: new IdLabelStruct(7, 'Continental Championships'),
    8: new IdLabelStruct(8, 'Other International Event'),
    9: new IdLabelStruct(9, 'National Championships'),
    10: new IdLabelStruct(10, 'National Competition')
};
/**
 * List of division info: code and name.
 */
WaHelperService.divisionInfo = {
    1: new IdLabelStruct(1, 'Recurve'),
    2: new IdLabelStruct(2, 'Compound'),
    3: new IdLabelStruct(3, 'Barebow'),
    4: new IdLabelStruct(4, 'Longbow'),
    5: new IdLabelStruct(5, 'Instinctive bow'),
    6: new IdLabelStruct(6, 'Target Recurve Bow'),
    7: new IdLabelStruct(7, 'Conventional Flight Bow'),
    8: new IdLabelStruct(8, 'American Longbow'),
    9: new IdLabelStruct(9, 'English Longbow'),
    10: new IdLabelStruct(10, 'Compound Flight Bow'),
    11: new IdLabelStruct(11, 'Compound Target Bow'),
    12: new IdLabelStruct(12, 'Foot Bow'),
};
/**
 * List of discipline info: code and name.
 */
WaHelperService.disciplineInfo = {
    1: new IdLabelStruct(1, 'Outdoor Archery'),
    2: new IdLabelStruct(2, 'Indoor Archery'),
    3: new IdLabelStruct(3, 'Field Archery'),
    4: new IdLabelStruct(4, '3D Archery'),
    5: new IdLabelStruct(5, 'Ski Archery'),
    6: new IdLabelStruct(6, 'Run Archery'),
    7: new IdLabelStruct(7, 'Clout Archery'),
    8: new IdLabelStruct(8, 'Flight Archery'),
    10: new IdLabelStruct(10, 'N/A')
};
WaHelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WaHelperService_Factory() { return new WaHelperService(i0.ɵɵinject(i1.LoggerService)); }, token: WaHelperService, providedIn: "root" });
